export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 11_00.9ec17867.jpg";